/**
 * «Ver como» (2026-10-07): el superadmin abre el sistema con los permisos de
 * otra persona, en sólo lectura y por 30 minutos. Su propia sesión queda
 * guardada en esta pestaña para volver.
 */
import {
  rec_api as api,
  rec_guardarSesion as guardarSesion,
  rec_leerClaims as leerClaims,
  rec_obtenerToken as obtenerToken,
  rec_obtenerUsuario as obtenerUsuario,
} from "../../runtime/index.jsx";

const CLAVE = `gth_ver_como_volver`;

export async function verComo(usuario) {
  const r = await api(`/permisos/usuarios/${usuario.id}/ver-como`, { method: `POST` });
  try {
    sessionStorage.setItem(CLAVE, JSON.stringify({ token: obtenerToken(), usuario: obtenerUsuario() }));
  } catch {}
  guardarSesion(r.token, r.usuario);
  window.location.assign(`/`);
}

export function viendoComo() {
  const c = leerClaims();
  return c?.verComo ? { nombre: c.nombre, actor: c.verComoNombre } : null;
}

export function volverDeVerComo() {
  let guardada = null;
  try {
    guardada = JSON.parse(sessionStorage.getItem(CLAVE) ?? `null`);
    sessionStorage.removeItem(CLAVE);
  } catch {}
  if (guardada?.token) {
    guardarSesion(guardada.token, guardada.usuario);
    window.location.assign(`/admin/maestros`);
  } else {
    localStorage.clear();
    window.location.assign(`/login`);
  }
}
